import { jsx as _jsx } from "react/jsx-runtime";
import { preventDefault } from '../../helpers';
import FormSection from './FormSection';
const Form = ({ className, onSubmit, children }) => (_jsx("form", Object.assign({ className: className, onSubmit: preventDefault(onSubmit) }, { children: children })));
export default Object.assign(Form, {
    Section: FormSection,
});
//# sourceMappingURL=Form.js.map